import {useMemo} from 'react';

import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';
import {TriggerAttachmentType} from 'src/openapi/models/TriggerAttachmentType';
import {useAppDispatch, useAppSelector} from 'src/store';

import {
    activateTriggerAttachment,
    addTriggerAttachment,
    deactivateTriggerAttachment,
    removeTriggerAttachment,
} from '../services/actions';
import {getTriggerAttachments} from '../services/selectors';

export const useEventTriggerAttachment = () => {
    const dispatch = useAppDispatch();
    const triggerAttachments = useAppSelector(getTriggerAttachments);
    const activeTriggerAttachmentsCount = useMemo(() =>
        triggerAttachments.filter((attachment: TriggerAttachment) => attachment.active).length, [triggerAttachments]);

    const addAttachment = (name: string, type: TriggerAttachmentType) => {
        dispatch(addTriggerAttachment({name, type, active: true}));
    };

    const removeAttachment = (attachment: TriggerAttachment) => {
        if (attachment.id) {
            dispatch(deactivateTriggerAttachment(attachment.id));
            return;
        }

        dispatch(removeTriggerAttachment(attachment.name));
    };

    const restoreAttachment = (attachment: TriggerAttachment) => {
        if (attachment.id) {
            dispatch(activateTriggerAttachment(attachment.id));
        }
    };

    return {
        triggerAttachments,
        activeTriggerAttachmentsCount,
        addAttachment,
        removeAttachment,
        restoreAttachment,
    };
};
